<div class="row" style="max-width: 1180px">
    <div class="col-md-4">
        <div class="card">
            <div class="card-body">
                <div class="section-photo-container">
                    <my-image-cropper
                        [initialImage]="initialImage"
                        (imageChange)="imageChanged($event)"
                    >
                        <p>Add an image to your business to customize emails and SMS landing pages.</p>
                    </my-image-cropper>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-8">
        <div class="card">
            <div class="card-body">
                <form [formGroup]="businessForm" (ngSubmit)="onSubmit()">
                    <div
                        class="trialBtn"
                        *ngIf="create && selectedReseller.id == GMRResellerId && permissions.changeBusinessTrialMode"
                        [ngClass]="businessForm.get('trialMode').value ? 'on' : 'off'"
                        (click)="updateTrialMode()"
                    >
                        Trial {{ businessForm.get('trialMode').value ? 'On' : 'Off' }}
                    </div>

                    <div
                        *ngIf="(!create && businessForm.get('trialMode').value) && selectedReseller.id == GMRResellerId && permissions.changeBusinessTrialMode"
                        class="trialBtn on"
                        (click)="convertTrial()"
                    >
                        Convert Account
                    </div>

                    <!-- 
                        [class.mt-5]="selectedReseller.id == GMRResellerId && permissions.changeBusinessTrialMode"
                    -->
                    <div class="form-group mt-4">
                        <label for="name" class="form-label form-label-required">
                            {{ 'business-form.nameLabel' | translate }}
                        </label>

                        <input 
                            class="form-control form-control-lg"
                            formControlName="name" 
                            id="name" 
                            name="name"
                            placeholder="{{ 'business-form.namePlaceholder' | translate }}" 
                            type="text"
                            [class.invalid-field]="businessForm.get('name').dirty && businessForm.get('name').invalid"
                        />
                    </div>

                    <div *ngIf="businessForm.get('trialMode').value" class="row">
                        <div class="form-group col-md-6 col-sm-12">
                            <label>Start Date</label>

                            <input
                                class="form-control"
                                formControlName="trialStartDate"
                                readonly
                                type="text"
                            >
                        </div>

                        <div class="form-group col-md-6 col-sm-12" *ngIf="!( selectedReseller.id == GMRResellerId && permissions.changeBusinessTrialDates)">
                            <label>End Date</label>

                            <input
                                class="form-control"
                                readonly
                                [value]="businessForm.get('trialEndDate').value | date:'MM/dd/yyyy'"
                            />
                        </div>

                        <div class="form-group col-md-6 col-sm-12" *ngIf="( selectedReseller.id == GMRResellerId && permissions.changeBusinessTrialDates)">
                            <label>End Date</label>

                            <input 
                                class="form-control" 
                                type="text"
                                placeholder="Select Date" 
                                class="form-control"
                                #datepickerMDY="bsDatepicker"
                                bsDatepicker
                                [minDate]="minDateEndTrial"
                                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY',adaptivePosition: true, containerClass: 'theme-blue' }"
                                formControlName="trialEndDate"
                            />
                        </div>
                    </div>

                    <div *ngIf="false" style="font-size: 12px">
                        {{ 'forms.obligatoy-fields' | translate }}
                    </div>

                    <div *ngIf="!create" class="mb-2">
                        <button
                            class="mt-2 btn btn-outline-primary"
                            type="submit"
                            [disabled]="!businessForm.valid"
                        >
                            {{ (!create ? 'business-form.editBusinessButton' : 'business-form.createBusinessButton') | translate }}
                        </button>

                        <button class="mt-2 ms-2 btn btn-outline-secondary" (click)="cancel.emit()">
                            {{ 'business-form.cancelButton' | translate }}
                        </button>
                    </div>

                    <button
                        *ngIf="create && !showLocationForm"
                        class="btn btn-primary mb-2"
                        type="button"
                        (click)="(selectedReseller.usedLicenses < selectedReseller.availableLicenses) ? showLocationForm = true : noAvailableLicenses()"
                    >
                        Add a Location
                    </button>
                </form>
            </div>

            <div *ngIf="create && showLocationForm" style="margin: -24px 0 -4px">
                <app-locations-form
                    (createLocation)="createBusinessWithLocation($event)" 
                    (cancel)="cancel.emit()"
                    (editLocation)="createLocation($event)"
                    [location]="formLocation" 
                    [create]="true"
                    [businessCreation]="true"
                />
            </div>
        </div>
    </div>
</div>
